import { render, staticRenderFns } from "./preferences-component.vue?vue&type=template&id=7992dbde&lang=html&"
import script from "./preferences-component.vue?vue&type=script&lang=js&"
export * from "./preferences-component.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports